import {
    Button,
    Flex,
    Input,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    SimpleGrid,
    Stat,
    StatLabel, useColorModeValue
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import 'react-toastify/dist/ReactToastify.css';
import { Filters, GetModelTypeRs } from 'utils/interfaces';


export default function ModelsFilter(
    { setFilters, modelTypes }:
    { setFilters: (filters: Filters<any>) => void, modelTypes: GetModelTypeRs[] }
) {

    // FILTERS
    const [selectedModelType, setSelectedModelType] = useState<GetModelTypeRs | null>(null);
    const [searchedModelName, setSearchedModelName] = useState("");

    const shadow = useColorModeValue(
        '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
        '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
    );


    const handleApplyFilters = () => {
        // Passa i filtri al componente Models
        setFilters({
            pageNumber: 0,
            modelTypeId: selectedModelType?.id || null,
            modelName: searchedModelName
        });
    };

    const resetFilters = () => {
        setSearchedModelName("");
        setSelectedModelType(null);
        setFilters({
            modelTypeId: null,
            modelName: ""
        });
    };

    return (
        <SimpleGrid
            px="10px"
            py="10px"
            backgroundColor="white"
            borderRadius="20px"
            boxShadow={shadow}
            columns={{ base: 2, md: 4, lg: 4, "2xl": 4 }}
            mb="20px"
            alignItems="center"
            justifyContent="center"
        >
            {/* Input per il nome modello */}
            <Card py="15px" gridColumn={{ base: "span 2", md: "span 1" }}>
                <Flex my="auto" h="100%" align="center" justify="center">
                    <Stat my="auto">
                        <StatLabel lineHeight="100%" fontWeight="bold" fontSize="sm">
                            Modello
                        </StatLabel>
                        <Flex mt="3%">
                            <Input
                                type="text"
                                borderRadius="6px"
                                size="sm"
                                placeholder="Cerca modello..."
                                value={searchedModelName}
                                onChange={(e) => setSearchedModelName(e.target.value)}
                                focusBorderColor="gray.500"
                                _hover={{ borderColor: "gray.500" }}
                            />
                        </Flex>
                    </Stat>
                </Flex>
            </Card>

            {/* Dropdown Tipo Modello */}
            <Card py="15px" gridColumn={{ base: "span 2", md: "span 1" }}>
                <Flex my="auto" h="100%" align="center" justify="center">
                    <Stat my="auto">
                        <StatLabel lineHeight="100%" fontWeight="bold" fontSize="sm">
                            Tipo Modello
                        </StatLabel>
                        <Menu>
                            <MenuButton
                                as={Button}
                                rightIcon={<IoIosArrowDown />}
                                mt="3%"
                                fontSize="sm"
                                variant="subtle"
                                width="100%"
                                size="xs"
                                color="gray.600"
                                textAlign="left"
                                fontWeight="normal"
                                border="1px solid"
                                borderColor="gray.300"
                                borderRadius="0.375rem"
                            >
                                {selectedModelType ? selectedModelType.type : "Tutti"}
                            </MenuButton>
                            <MenuList textAlign="left" fontSize="sm" maxHeight="220px" overflowY="auto">
                                <MenuItem onClick={() => setSelectedModelType(null)}>Tutti</MenuItem>
                                {modelTypes.map((modelType) => (
                                    <MenuItem _hover={{ bg: "gray.200" }} key={modelType.id} onClick={() => setSelectedModelType(modelType)}>
                                        {modelType.type}
                                    </MenuItem>
                                ))}
                            </MenuList>
                        </Menu>
                    </Stat>
                </Flex>
            </Card>

            {/* Pulsanti posizionati sempre alla fine */}
            <Flex gridColumn="span 2" justifyContent="flex-end" gap="10px" mt="10px">
                <Button
                    onClick={handleApplyFilters}
                    _hover={{ bg: "gray.700" }}
                    _active={{ bg: "gray.600" }}
                    _focus={{ boxShadow: "none" }}
                    backgroundColor="#688CC8"
                    color="white"
                    height="30px"
                    borderRadius="6px"
                    cursor="pointer"
                    fontSize="sm"
                >
                    Applica Filtri
                </Button>

                <Button
                    onClick={resetFilters}
                    _hover={{ bg: "gray.100" }}
                    _active={{ bg: "gray.200" }}
                    _focus={{ boxShadow: "none" }}
                    backgroundColor="white"
                    color="#688CC8"
                    height="30px"
                    cursor="pointer"
                    fontSize="sm"
                >
                    Azzera Filtri
                </Button>
            </Flex>
        </SimpleGrid>

    );
}
